export default __webpack_public_path__ + "static/media/icono-informacion.92f66ad0.svg";